import type {
  AiApplicationDto,
  UpdateAiApplicationDto,
} from '@terra/shared-contracts-ai-applications';
import type { AiApplicationInterfaceRow } from './AiApplicationInterfacesEditor';
import type { AiApplicationInterfaceType } from './AiApplicationProtocolSelector';
import { withInterfaceBodyExample } from './aiInterfaceMetadata';

export function buildAiApplicationInterfaceUpdate({
  baseUrl,
  interfaceTypes,
  interfaceRows,
  storedInterfaces,
}: {
  baseUrl: string;
  interfaceTypes: AiApplicationInterfaceType[];
  interfaceRows: AiApplicationInterfaceRow[];
  storedInterfaces: AiApplicationDto['interfaces'];
}): UpdateAiApplicationDto {
  return {
    url: baseUrl.trim(),
    interfaceTypes,
    interfaces: interfaceRows.map((row) => {
      const originalInterface = storedInterfaces.find(
        (item) => item.id === row.id,
      );
      const urlUnchanged =
        originalInterface != null && row.url === originalInterface.url;
      const originalMetadata = originalInterface?.metadata ?? null;

      if (urlUnchanged && originalMetadata) {
        return {
          id: row.id,
          name: row.name ?? null,
          url: row.url,
          type: row.type,
          authSummary: null,
          metadata: withInterfaceBodyExample({
            metadata: originalMetadata,
            bodyExample: row.bodyExample,
          }),
        };
      }

      return {
        id: row.id,
        name: row.name ?? null,
        url: row.url,
        type: row.type,
        authSummary: null,
        metadata: withInterfaceBodyExample({
          metadata: {
            discoveryPending: true,
            probeStatus: 'PENDING' as const,
          },
          bodyExample: row.bodyExample,
        }),
      };
    }),
  };
}
